module.exports = __webpack_public_path__ + "static/media/27OCHA1.d22903db.jpg";